import(/* webpackMode: "eager" */ "/app/apps/portal/src/app/error.tsx");
